import { render, staticRenderFns } from "./RequestsHistoryList.vue?vue&type=template&id=265ab4e6"
import script from "./RequestsHistoryList.vue?vue&type=script&lang=js"
export * from "./RequestsHistoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports